import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { StockAlert } from 'src/app/domain/models/StockAlert';

@Component({
  selector: 'app-view-stock-alerts',
  templateUrl: './view-stock-alerts.component.html',
  styleUrls: ['./view-stock-alerts.component.css']
})
export class ViewStockAlertsComponent implements OnInit, OnChanges {

  @Input()
  alerts: StockAlert[] = []
  containerDuplicated: string[] = [];
  containerUsed: string[] = [];
  messageDuplicated: string = "";
  messageUsed: string = "";

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['alerts'])
    {

    }
  }

  buildMessages()
  {

    if(this.alerts.length > 0)
    {
      this.alerts.forEach(element => {
        if(element.type == 0){
          this.containerDuplicated.push(element.containerNumber);
        }else{
           this.containerUsed.push(element.containerNumber);
        }
      });

      if(this.containerDuplicated.length > 0)
      {
        this.messageDuplicated = this.containerDuplicated.join("," );
      }

      if(this.containerUsed.length > 0)
      {
        this.messageDuplicated = this.containerUsed.join("," );
      }

    }
  }



}
